import { render, staticRenderFns } from "./StrokeLeftBottomIcon.vue?vue&type=template&id=1967b1c8&"
import script from "./StrokeLeftBottomIcon.vue?vue&type=script&lang=js&"
export * from "./StrokeLeftBottomIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports